export default __webpack_public_path__ + "static/media/08.2acd6ede.mp3";